import React from 'react'
import { FormInputSelectAndNavigate } from '../../../../../../../ui/organisms'
import { toJS } from 'mobx'

export default {
  title: 'Which party is paying you for this project?',
  next: 'projectInfo.projectContractValue',
  component: (props) => {
    let options = [  
      'Property Owner / Developer'
    ]

    const data = props.document.data?.get('projectInfo')
    const projectRole = data?.get('projectRole')
    const projectType = data?.get('projectType')
    const residentialProjectType = data?.get('residentialProjectType')
    const commercialProjectType = data?.get('commercialProjectType')

    if(['Sub-contractor & General-contractor', 'General Contractor'].includes(projectRole)){
      options.unshift('General Contractor')
    }

    if(projectRole === 'Sub-contractor'){
      options.unshift('Another sub-contractor who is in contract with the general contractor')
    }

    if(['New construction multi-family units', 'Remodeling multi-family units'].includes(residentialProjectType) || ['Mulitunit Residential Building'].includes(commercialProjectType)){
      options.push('Condominium Association')
    }

    if(['Private Commercial'].includes(projectType) || ['Remodeling single family unit','Remodeling multi-family units'].includes(residentialProjectType)){
      options.push('Property Manager')
    }

    if(['State Construction'].includes(projectType)){
      options.push('State, County, City, Local Government')
    }

    if(['Federal Construction'].includes(projectType)){
      options.push('Federal Government')
    }

    options.push('Other')

    return(
      <FormInputSelectAndNavigate options={options} {...props}/>
    )
  }
}